import { render, staticRenderFns } from "./Pause.vue?vue&type=template&id=0c9a07b8"
import script from "./Pause.vue?vue&type=script&lang=js"
export * from "./Pause.vue?vue&type=script&lang=js"
import style0 from "./Pause.vue?vue&type=style&index=0&id=0c9a07b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports